import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-editor-dialog',
    templateUrl: './editor-dialog.component.html',
    styleUrls: ['./editor-dialog.component.scss'],
    standalone: false
})
export class EditorDialogComponent implements OnInit {

  _model;
  @Input() set model(model){
    this._model = model;
    this.initData();
  };
  @Input() gameId;
  @Input() templateId;

  _characters;
  @Input() set characters(characters){
    this._characters = characters;
    if(this._model && this._model.data){
      this.initData();
    }
  };
  @Input() languages;
  @Input() defaultLang;
  @Input() editMode = false;
  @Input() htmlMode = true;

  selectedCharacter;
  selectedMood;

  constructor(private router: Router) {
  }

  ngOnInit() {
  }

  initData(){
    if(this._model.data){
      if(!this._model.data.text){
        this._model.data.text = {}
      }
      
      if(!this._model.data.image){
        this._model.data.image = {}
      }
    }
    if(this._model.data.characterId && this._characters){
      console.log('identify char:'+this._model.data.characterId);
      for(let character of this._characters){
        if(character.id == this._model.data.characterId){
          this.selectedCharacter = character;
          console.log('identify mood:'+this._model.data.moodId);
          for(let mood of character.moods){
            if(mood.id == this._model.data.moodId){
              console.log('mood found:'+mood.id);
              this.selectedMood = mood;
            }
          }
        }
      }
    }
  }

  onCharacterChange(){
    this._model.data.characterId = this.selectedCharacter.id;
    for(let character of this._characters){
      if(character.id == this.selectedCharacter.id){
        for(let mood of character.moods){
          this._model.data.moodId = mood.id;
          //this._model.data.charIconURL = mood.fileURL;
          delete this._model.data.charIconURL;
          break;
        }
      }
    }
  }

  onMoodChange(){
    this._model.data.moodId = this.selectedMood.id;
    delete this._model.data.charIconURL;
    //this._model.data.charIconURL = this.selectedMood.fileURL;
  }

}
